import { MouseEventHandler } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

export default function AzureSPConnectErrorPhase(
  props: DisabledProps | ActiveProps
): JSX.Element | null {
  if (!props.shown) {
    return null;
  }

  //
  const { onNext, message } = props;

  //
  return (
    <ServiceConnectionStep disabled={false} sx={{ background: "#FCC" }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          There was an error connecting to Microsoft Azure:
        </Typography>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body1">
          {message ?? "Something went wrong"}
        </Typography>
      </Box>
      <Button
        variant="contained"
        onClick={onNext as MouseEventHandler<HTMLButtonElement>}
      >
        Delete Bad Connections And Start Over
      </Button>
    </ServiceConnectionStep>
  );
}

// -----------------------------------------------------------------------------

interface DisabledProps {
  shown: false;
}

interface ActiveProps {
  shown: true;
  onNext: Function;
  message?: string;
}
